import React, { ReactElement } from "react";

export default function AuthLoading(): ReactElement {
  return <div>Anmeldung läuft</div>;
}
